/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_NavigationInputs */



/**
* | output |
* | --- |
* | "Options navigation" |
*
* @param {Options_NavigationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_navigation = /** @type {((inputs?: Options_NavigationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_NavigationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Navigation des options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen-Navigation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di navigazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры навигации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de navegación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选项导航")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプションナビゲーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्प नेविगेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Navegação de opções")
	return /** @type {LocalizedString} */ ("Options navigation")
});